import styled from "styled-components";

export const StyledButton = styled.div`
  display: flex;
  gap: 16px; /* Adjust the gap as needed */
`;